import React, { useState } from "react";
import { Typography, Box, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { BsSearch } from "react-icons/bs";
import { PROFILES_API } from "../../api";
import { addNewMessage } from "../../slice";
import { useCurrentState } from "../../hooks";
import ConfirmModal from "../ConfirmModal";

function NoResult() {
  const dispatch = useDispatch();
  const updateUserStatus = useCurrentState();
  const { data } = useSelector((state) => state.UserCurrentState);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);

  const { mutate: ChooseSearchByType } = useMutation(() => PROFILES_API.ChooseSearchByType(true), {
    onError: () => {
      setOpenConfirmationModal(false);
      dispatch(
        addNewMessage({
          id: "error-on-search",
          text: "مشکلی برای ارسال درخواست شما به وجود آمده است.",
          type: "error",
        })
      );
    },
    onSuccess: () => {
      setOpenConfirmationModal(false);
      updateUserStatus();
      dispatch(
        addNewMessage({
          text: "درخواست شما با موفقیت ارسال شد.",
          id: "success-on-search",
          type: "success",
        })
      );
    },
  });

  const handleClick = () => {
    const accessCodes = [8, 65, 70];
    if (accessCodes.includes(parseInt(data?.code))) {
      ChooseSearchByType();
    } else {
      dispatch(
        addNewMessage({
          id: "failed-on-use",
          text: "متقاضی گرامی در وضعیت کنونی شما امکان استفاده از این قابلیت برای شما فراهم نییست.",
          type: "error",
        })
      );
    }
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" my={10} width="100%">
      <ConfirmModal
        message="متقاضی گرامی درصورت انتخاب درخواست به مرکز، امکان ادامه‌ی جستجو و ارسال کاندیدهای منتخب توسط خود شما وجود ندارد. آیا اطمینان دارید؟"
        open={openConfirmationModal}
        onClose={() => setOpenConfirmationModal(false)}
        onSubmit={handleClick}
      />
      <BsSearch color="#FB83AC" fontSize={50} />
      <Typography variant="h6" mt={2}>
        ,جستجو موفقیت آمیز نبود
      </Typography>
      <Typography variant="h6" mt={2}>
        .با پارامترهای دیگری تلاش کنید
      </Typography>
      <Box
        width="60%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        p={3}
        my={5}
        bgcolor="#EEEEEE  "
        borderRadius={3}
      >
        <Typography variant="h6" textAlign="center" mb={1} color="#000000">
          ...اگر با تغییر پارامتر ها هیچ نتیجه‌ای نمی گیرید
        </Typography>
        <Typography variant="h6" textAlign="center" mb={4} color="#000000">
          ...پیشنهاد می کنیم این کار را به کارشناسان مرکز بسپارید
        </Typography>
        <Button variant="m3" onClick={() => setOpenConfirmationModal(true)}>
          درخواست به مرکز
        </Button>
      </Box>
    </Box>
  );
}

export default NoResult;
